export default __webpack_public_path__ + "static/media/banner-video.ecd0d1a6.mp4";